$btnHeight: 32px;
$btnBorderRadius: 16px;
$btnFontSize: 14px;

:host {
  pointer-events: none;
  cursor: default;
}

:host(:not([isActive])[isEnabled]),
:host([isOptional]) {
  pointer-events: initial;
  cursor: pointer;
}

.step {
  display: flex;
  flex-flow: column;
  align-items: center;
  padding: 20px 40px;
  position: relative;
}

.wizard-icon {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
  width: 32px;
}

.line {
  content: '';
  background: var(--chart-101-pressed-dividers);
  height: 1px;
  display: block;
  width: 100%;
  position: absolute;
  top: 36px;
  right: calc(50% - 16px);
}

.threshold {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  color: var(--main-titles-inputs-600);
  font-size: var(--body-size-medium);
  font-family: 'Montserrat', sans-serif;
  height: 32px;
  width: 32px;
  border-radius: 50%;
  border: 1px solid var(--chart-100-pressed);
  background: var(--white-layout-303-level-2-elevation);
}

.title {
  display: flex;
  justify-content: center;
  padding: 8px 0;
}

.text {
  text-align: center;
  color: var(--chart-300-icon-buttons);
}

.success-icon {
  display: flex;
}

.fail-icon {
  display: flex;
}

:host(:hover) {
  background-color: var(--chart-050-hover);
}

:host([isVisited]),
:host([isActive]) {
  .line {
    background: var(--blue-layout-400-primary);
    opacity: 1;
  }
}

:host([isActive]),
:host([isActive][status='complete']) {
  .threshold {
    border-color: var(--blue-layout-400-primary);
    color: var(--blue-layout-400-primary);
  }
  .title {
    color: var(--blue-layout-400-primary);
  }
}

:host([status='complete']) {
  .title {
    color: var(--main-titles-inputs-600);
  }
}

:host([status='incomplete']) {
  .title {
    color: var(--red-layout-301-primary);
  }
}
